import {inject, Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {map, tap} from "rxjs/operators";
import {BehaviorSubject} from "rxjs";
import {Doctor} from "@interfaces/doctors";
import {EnvironmentService} from '@services/enviroment/environment.service';
import {Kits} from '@interfaces/kits';

@Injectable({
  providedIn: 'root'
})
export class DoctorsService {
  doctorsList: BehaviorSubject<Doctor[]> = new BehaviorSubject<Doctor[]>([]);
  doctorsListLocal: Doctor[] = [];
  page = 1;
  pageLimit?: number;
  perPage = 10;

  doctorsListObservable$ = this.doctorsList.asObservable();
  kitsList: BehaviorSubject<Kits[]> = new BehaviorSubject<Kits[]>([]);

  protected readonly http = inject(HttpClient);
  private environmentService = inject(EnvironmentService);

  apiUrl = this.environmentService.getValue('apiUrl');

  fetchDoctors(page?: number) {
    return this.http.get(this.apiUrl + '/doctors', {
      params: {
        page: page || this.page,
        per_page: this.perPage
      }
    })
      .pipe(
        tap((res: any) => {
          if (res.metadata.total_pages) {
            this.page = res.metadata.current_page;
            this.pageLimit = res.metadata.total_pages;
          }
        }),
        map((res: any) => res.doctors),
      );
  }

  fetchReports() {
    return this.http.get(this.apiUrl + '/reports')
      .pipe(
        map((res: any) => res.reports),
      );
  }

  fetchKits(patientId: string) {
    return this.http.get(this.apiUrl + '/patients/' + patientId + '/kits')
      .pipe(
        map((res: any) => res.kits),
      );
  }

  // get doctorsListObservable$() {
  //   return this.doctorsList.asObservable();
  // }

  updateDoctorsList(doctors: Doctor[], pageLimit?: number) {
    if (pageLimit) {
      this.perPage = pageLimit;
    }

    this.doctorsListLocal.push(...doctors);
    this.doctorsList.next(this.doctorsListLocal);
  }

  resetDoctorsList(doctors: Doctor[], pageLimit?: number) {
    if (pageLimit) {
      this.perPage = pageLimit;
    }
    this.doctorsListLocal = doctors;
    this.page = 1;
    this.doctorsList.next(this.doctorsListLocal);
  }


  deleteDoctor(id: string) {
    return this.http.delete(this.apiUrl + '/doctors/' + id)
      .pipe(
        map((res: any) => res.doctor),
        tap(() => {
          this.doctorsListLocal = this.doctorsListLocal.filter(doctor => doctor.id !== id);
          this.doctorsList.next(this.doctorsListLocal);
        })
      );

  }
}
